/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Salary_DataInputs */

const en_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary data`)
};

const de_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsdaten`)
};

const fr_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données salariales`)
};

const es_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos salariales`)
};

const it_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati salariali`)
};

const nl_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisgegevens`)
};

const pl_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane dotyczące wynagrodzenia`)
};

const fi_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatiedot`)
};

const da_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lønsdata`)
};

const sv_settings_feature_salary_data = /** @type {(inputs: Settings_Feature_Salary_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lönedata`)
};

/**
* | output |
* | --- |
* | "Salary data" |
*
* @param {Settings_Feature_Salary_DataInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_salary_data = /** @type {((inputs?: Settings_Feature_Salary_DataInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Salary_DataInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_salary_data(inputs)
	if (locale === "fr") return fr_settings_feature_salary_data(inputs)
	if (locale === "es") return es_settings_feature_salary_data(inputs)
	if (locale === "it") return it_settings_feature_salary_data(inputs)
	if (locale === "nl") return nl_settings_feature_salary_data(inputs)
	if (locale === "pl") return pl_settings_feature_salary_data(inputs)
	if (locale === "fi") return fi_settings_feature_salary_data(inputs)
	if (locale === "da") return da_settings_feature_salary_data(inputs)
	if (locale === "sv") return sv_settings_feature_salary_data(inputs)
	return en_settings_feature_salary_data(inputs)
});